const HEX_COLOR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

// Returns the brand color from env only if it is a valid hex color, else null (keeps CSS default)
export const getPrimaryColor = (): string | null => {
  const color = (import.meta.env.PRIMARY_COLOR as string) || '';

  return HEX_COLOR.test(color) ? color : null;
};

// Darkens a hex color toward black; used for the button hover state
// (the app's convention is a darker hover, see COLORS in constants.ts)
export const darken = (hex: string, amount = 0.1): string => {
  const full =
    hex.length === 4 ? `#${[...hex.slice(1)].map((c) => c + c).join('')}` : hex;
  const num = parseInt(full.slice(1), 16);
  const channel = (shift: number) =>
    Math.max(0, ((num >> shift) & 0xff) - Math.round(255 * amount));
  const value = (channel(16) << 16) | (channel(8) << 8) | channel(0);

  return `#${value.toString(16).padStart(6, '0')}`;
};

// Overrides the primary brand color CSS variables when PRIMARY_COLOR is set
export const applyBrandColor = (
  root: HTMLElement = document.documentElement,
): void => {
  const color = getPrimaryColor();

  if (!color) {
    return;
  }

  root.style.setProperty('--primary-color', color);
  root.style.setProperty('--primary-color-hover', darken(color));
};
